import httpClient from "@/services/httpClient";
import { server, trademark_const } from "@/services/constants";

export const getAllAppointment200 = () => {
  return httpClient.get(`${trademark_const.trademark_url}/` + server.APPOINTMENT + `/getAllLimit200`);
};
export const getAllPTAppointment200 = () => {
  return httpClient.get(`${trademark_const.trademark_url}/` + server.APPOINTMENT + `/getAllPTLimit200`);
};

export const getAllAppointment = () => {
  return httpClient.get(`${trademark_const.trademark_url}/` + server.APPOINTMENT + `/getAll`);
};

export const AppointmentgetById = (id) => {
  return httpClient.get(`${trademark_const.trademark_url}/` + server.APPOINTMENT + `/getById/${id}`);
};

export const searchdataAppointment = (query) => {
  return httpClient.get(`${trademark_const.trademark_url}/` + server.APPOINTMENT + `/searchdata`, query);
};
export const searchdataAppointmentPT = (query) => {
  return httpClient.get(`${trademark_const.trademark_url}/` + server.APPOINTMENT + `/searchdatapt`, query);
};

export const AppointmentAdd = (data) => {
  return httpClient.post(`${trademark_const.trademark_url}/` + server.APPOINTMENT, data);
};
export const AppointmentAddV2 = (data) => {
  return httpClient.post(`${trademark_const.trademark_url}/` + server.APPOINTMENT + `/v2`, data);
};
export const createSotfFile = (appointment_id, data) => {
  return httpClient.put(
    `${trademark_const.trademark_url}/` + server.APPOINTMENT + `/create-sotf-file/${appointment_id}`,
    data
  );
};

export const AppointmentUpdate = (id, data) => {
  return httpClient.put(`${trademark_const.trademark_url}/` + server.APPOINTMENT + `/${id}`, data);
};
export const AppointmentUpdateV2 = (id, data) => {
  return httpClient.put(`${trademark_const.trademark_url}/` + server.APPOINTMENT + `/v2/${id}`, data);
};
export const updateRecieptfile = (id, data) => {
  return httpClient.put(`${trademark_const.trademark_url}/` + server.APPOINTMENT + `/update-recept-file/${id}`, data);
};
export const updateSoftfile = (id, data) => {
  return httpClient.put(`${trademark_const.trademark_url}/` + server.APPOINTMENT + `/update-soft-file/${id}`, data);
};
export const updateSoftfileTM = (id, data) => {
  return httpClient.put(`${trademark_const.trademark_url}/` + server.APPOINTMENT + `/update-soft-file-tm/${id}`, data);
};

export const AppointmentDelete = (id) => {
  return httpClient.delete(`${trademark_const.trademark_url}/` + server.APPOINTMENT + `/${id}`);
};
export const AppointmentDeleteMode = (id) => {
  return httpClient.delete(`${trademark_const.trademark_url}/` + server.APPOINTMENT + `/mode/${id}`);
};

export const AppointmentUpdateclientname = (refno, data) => {
  return httpClient.put(
    `${trademark_const.trademark_url}/` + server.APPOINTMENT + `/updateclientname/${refno}`,
    data
  );
};

export const AppointmentImportxlsx = (data) => {
  return httpClient.post(`${trademark_const.trademark_url}/` + server.APPOINTMENT + `/importxlsx`, data);
};

export const AppointmentImportxlsxpatent = (data) => {
  return httpClient.post(`${trademark_const.trademark_url}/` + server.APPOINTMENT + `/importxlsxpatent`, data);
};

export const getfile_noforappointment = (searchfile_no) => {
  return httpClient.get(`${trademark_const.trademark_url}/` + server.APPOINTMENT + `/getfile_no/${searchfile_no}`);
};

export const getfile_noTmforappointment = (searchfile_no) => {
  return httpClient.get(`${trademark_const.trademark_url}/` + server.APPOINTMENT + `/getfile_notm/${searchfile_no}`);
};

// Query Parameters: getAllAppointmentPagination
// - page: หน้าที่ต้องการ (default: 1)
// - limit: จำนวนรายการต่อหน้า (default: 10)
// - sortBy: ฟิลด์ที่ต้องการเรียงลำดับ (default: 'appointment_id')
// - sortOrder: ลำดับการเรียง 'ASC' หรือ 'DESC' (default: 'ASC')
// - searchdocumenttype: ประเภทเอกสาร
// - searchtrademark_name: ชื่อเครื่องหมายการค้า
// - searchfile_no: หมายเลขไฟล์
// - searchapp_no: หมายเลขใบสมัคร
// - searchdatefrom: วันที่เริ่มต้น
// - searchdateto: วันที่สิ้นสุด

export const getAllAppointmentPagination = (
  page,
  limit,
  sortBy,
  sortOrder,
  searchdocumenttype,
  searchtrademark_name,
  searchfile_no,
  searchapp_no,
  searchdatefrom,
  searchdateto,
  status
) => {
  return httpClient.get(`${trademark_const.trademark_url}/` + server.APPOINTMENT + `/searchdataPagination`, {
    params: {
      page,
      limit,
      sortBy,
      sortOrder,
      searchdocumenttype,
      searchtrademark_name,
      searchfile_no,
      searchapp_no,
      searchdatefrom,
      searchdateto,
      status
    },
  });
};



// Parameters: searchdataPTAppointmentPagination
// - page: หมายเลขหน้า (default: 1)
// - limit: จำนวนรายการต่อหน้า (default: 10)
// - sortBy: ฟิลด์ที่ต้องการเรียงลำดับ (default: am.appointment_id)
// - sortOrder: ลำดับการเรียง ASC/DESC (default: ASC)
// - searchdocumenttype: รหัสประเภทเอกสาร
// - searchtrademark_name: ชื่อเครื่องหมายการค้า
// - searchfile_no: หมายเลขไฟล์
// - searchapp_no: หมายเลขใบสมัคร
// - searchdatefrom: วันที่เริ่มต้น
// - searchdateto: วันที่สิ้นสุด

export const loadDataExportTm = (
  searchdocumenttype,
  searchtrademark_name,
  searchfile_no,
  searchapp_no,
  searchdatefrom,
  searchdateto,
  status
) => {
  return httpClient.get(`${trademark_const.trademark_url}/` + server.APPOINTMENT + `/load-data-export-tm`, {
    params: {
      searchdocumenttype,
      searchtrademark_name,
      searchfile_no,
      searchapp_no,
      searchdatefrom,
      searchdateto,
      status
    },
  });
};
export const loadDataExportTPt = (
  searchdocumenttype,
  searchtrademark_name,
  searchfile_no,
  searchapp_no,
  searchdatefrom,
  searchdateto,
  status
) => {
  return httpClient.get(`${trademark_const.trademark_url}/` + server.APPOINTMENT + `/load-data-export-pt`, {
    params: {
      searchdocumenttype,
      searchtrademark_name,
      searchfile_no,
      searchapp_no,
      searchdatefrom,
      searchdateto,
      status
    },
  });
};
export const searchdataPTAppointmentPagination = (
  page,
  limit,
  sortBy,
  sortOrder,
  searchdocumenttype,
  searchtrademark_name,
  searchfile_no,
  searchapp_no,
  searchdatefrom,
  searchdateto,
  status
) => {
  return httpClient.get(`${trademark_const.trademark_url}/` + server.APPOINTMENT + `/searchdatapt-pagination`, {
    params: {
      page,
      limit,
      sortBy,
      sortOrder,
      searchdocumenttype,
      searchtrademark_name,
      searchfile_no,
      searchapp_no,
      searchdatefrom,
      searchdateto,
      status
    },
  });
};

export const newAppointment = (data) => {
  return httpClient.post(`${trademark_const.trademark_url}/` + server.APPOINTMENT + `/new-appointment`, data);
};
export const updateAppointmentTM = (id, data) => {
  return httpClient.put(`${trademark_const.trademark_url}/` + server.APPOINTMENT + `/update-appointmenttm/${id}`, data);
};
export const createDataFile = (id, data) => {
  return httpClient.put(`${trademark_const.trademark_url}/` + server.APPOINTMENT + `/create-data-file/${id}`, data);
};
export const createDataSoftFile = (id, data) => {
  return httpClient.put(`${trademark_const.trademark_url}/` + server.APPOINTMENT + `/create-data-softfile/${id}`, data);
};